import('./bootstrap').catch((err): void => console.error(err));
